import Vue from 'vue'
import { ONL_AUTH_FIELDS } from '@/store/mutation-types'
import { getAction } from '@/api/manage'

const online = {
  state: {
    //存储对象属性 value,text
    authFields: [],
    // 在线表单数据多语言
    langFieldMap: {},
    // 主表中当前列表数据多语言字段
    tableLangField: [],
    // 子表中当前列表数据多语言字段
    subLangField: [],
    // 当前列表多语言信息
    tableLangMap: {},
    // 每个表中开启多语言配置的字段（后端返回的源数据），表名做key
    langFieldSourceMap: {},
  },
  mutations: {
    SET_AUTHFIELDS: (state, fields) => {
      console.log('fields', fields)
      Vue.set(state, 'authFields', fields)
    },
    SET_LANGFIELDMAP(state, obj) {
      // 保存后进行清空处理
      if (!obj) return state.langFieldMap = {}
      state.langFieldMap = {
        ...state.langFieldMap,
        ...obj
      }
    },
    SET_TABLELANGFIELD(state, arr) {
      state.tableLangField = arr
    },
    SET_SUBLANGFIELD(state, arr) {
      state.subLangField = arr
    },
    SET_TABLELANGLIST(state, obj) {
      state.tableLangMap = obj
    },
    SET_LANGFIELDSOURCEMAP(state, obj) {
      state.langFieldSourceMap = { ...obj }
    }
  },
  actions: {}
}

export default online